import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginRequestDto } from '@services/authentication/model/loginRequestDto';
import { OAuth2TokensDto } from '@services/authentication/model/oAuth2TokensDto';
import { ReloginRequestDto } from '@services/authentication/model/reloginRequestDto';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import {WebOwnProfileModel} from "@services/back-office/model/webOwnProfileModel";
import {PageFeedbackTopicDto} from '@services/associations';

@Injectable({providedIn: 'root'})
export class LoginService {
  private baseUrl = environment.baseUrl;

  constructor(
    private http: HttpClient,
  ) { }

  logIn(request: LoginRequestDto): Observable<OAuth2TokensDto> {
    const url = `${this.baseUrl}/authentication/login`;
    return this.http.post<OAuth2TokensDto>(url, request);
  }

  reLogin(request: ReloginRequestDto): Observable<OAuth2TokensDto> {
    const url = `${this.baseUrl}/authentication/relogin`;
    return this.http.post<OAuth2TokensDto>(url, request);
  }

  /** Get Permissions by HEX string */
  getPermissionsByHex(query: string[]): Observable<PageFeedbackTopicDto> {
    const url = `${this.baseUrl}/authentication/permissions`;
    return this.http.post<PageFeedbackTopicDto>(url, query);
  }

  /** Load Current User */
  loadCurrentUser(): Observable<WebOwnProfileModel> {
    const url = `${this.baseUrl}/back-office/v1/users/profile/own`;
    return this.http.get<WebOwnProfileModel>(url);
  }

  /** Отримати QR-код для входу: id — для опитування авторизації, name — лінка, яку кодуємо в QR */
  getQrCode(): Observable<QrCodeModel> {
    const url = `${this.baseUrl}/organization/v1/qr/get`;
    return this.http.get<QrCodeModel>(url);
  }

  /** Авторизація за QR-кодом: поки мобільний застосунок не відсканував код, бекенд відповідає 400 qr_code_not_scanned */
  qrLogin(qrCodeId: string): Observable<OAuth2TokensDto> {
    const url = `${this.baseUrl}/organization/v1/qr/login/${qrCodeId}/${LoginRequestDto.ClientIdEnum.BackOffice}`;
    return this.http.get<OAuth2TokensDto>(url);
  }
}

export interface QrCodeModel {
  id?: string;
  name?: string;
}
